var map = {
	"./beta-0.json": 137,
	"./beta-1-tutorial.json": 138,
	"./beta-2-cut-1.json": 139,
	"./beta-3-cut-2.json": 140,
	"./beta-4-spikes.json": 141,
	"./beta-5-multi-e.json": 142,
	"./beta-6-jump.json": 143,
	"./beta-7-multi-m.json": 144,
	"./beta-8-multi-h.json": 145,
	"./beta-demo-lasers.json": 146,
	"./beta-t-basement.json": 147,
	"./beta-t-double-under.json": 148,
	"./beta-t-elevator.json": 149,
	"./beta-t-single-1.json": 150,
	"./beta-t-single-2-h.json": 151,
	"./beta-t-single-3.json": 152,
	"./friend-1-vert.json": 153,
	"./friend-10-laser-4.json": 154,
	"./friend-11-laser-5.json": 155,
	"./friend-2-basement-v2.json": 156,
	"./friend-3-move-1.json": 157,
	"./friend-4-vert-spike.json": 158,
	"./friend-5-dia-multi.json": 159,
	"./friend-6-drop.json": 160,
	"./friend-7-laser-1.json": 161,
	"./friend-8-laser-2.json": 162,
	"./friend-9-laser-3.json": 163,
	"./kong-1-opposing.json": 164,
	"./kong-2-shield.json": 165,
	"./kong-3-box.json": 166,
	"./kong-4-switcheroo.json": 167,
	"./kong-5-triangle.json": 168,
	"./new-1-vert-ab.json": 169,
	"./new-2-drop-ab.json": 170,
	"./new-3-multi-m-ab.json": 171,
	"./new-4-multi-h-ab.json": 172,
	"./new-5-multi-e.json": 173,
	"./paper-easy.json": 174,
	"./paper-hard.json": 175,
	"./paper-medium.json": 176,
	"./test1.json": 25,
	"./test2.json": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;


//////////////////
// WEBPACK FOOTER
// ./levels ./node_modules/json-loader ^\.\/.*\.json$
// module id = 136
// module chunks = 0